import { render, staticRenderFns } from "./LangMobile.vue?vue&type=template&id=067f948e"
import script from "./LangMobile.vue?vue&type=script&lang=js"
export * from "./LangMobile.vue?vue&type=script&lang=js"
import style0 from "./LangMobile.vue?vue&type=style&index=0&id=067f948e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports